import { useIdleTimer } from 'react-idle-timer'
import useLogout from './useLogout'

const INACTIVIY_TIMEOUT =
  process.env.REACT_APP_INACTIVIY_TIMEOUT ?? 60 * 60 * 1000

const useSessionInactivity = () => {
  const { logout } = useLogout()

  const onIdle = () => {
    logout('/login')
  }

  useIdleTimer({ timeout: INACTIVIY_TIMEOUT, onIdle })
}

export default useSessionInactivity
